import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_14 = ({ book, user }) => ({
    3: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",
            // ===== Short step cards =====
            icon1: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title1: "Buy the Hardcover - BuyOut",
            description1: "Use the link below to purchase the book. Then click the 'Next Step' button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Upload proof of purchase",
            description2: "Upload a clear screenshot/photo of your Amazon order. Reading the book is up to you.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: `Purchase the Hardcover version directly on Amazon (BuyOut). Reimbursement: +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? book.selectedCurrentUserAssign?.assignment_price_amz ?? 'the book’s retail price'} (excluding delivery)`,
            full_subtitle1: "No public review required. Proof of purchase is mandatory.",
            full_description1: (
                <p>
                    Please purchase the <b>exact hardcover ASIN</b> listed for this assignment.
                    Do <b>not</b> buy used copies
                    or from third-party sellers. Keep your <b>Order ID</b> handy. Reimbursement covers the
                    book’s retail price
                    <b> excluding delivery costs</b>. Use the button below to open the Amazon page and
                    complete your purchase.
                </p>
            ),

            full_title2: "Upload your proof of purchase",
            full_subtitle2: "Make sure the screenshot/photo clearly shows key details.",
            full_description2: (
                <p>
                    Upload a <b>clear screenshot or photo</b> of your Amazon order page that shows the Order
                    ID or number,
                    the book title (or ASIN), the order date, the price paid for the book, and your Amazon
                    account name.
                    Files must be readable, and blurred or cropped images may be rejected.
                </p>
            ),


            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <>
                    Our team is verifying your purchase with the provided screenshots/photos and Amazon order details.
                    If anything is missing or unclear, we’ll ask you to re-upload the files. Once approved, we will
                    credit your <b>Virt</b> and reimburse the <b>book’s retail price (excluding delivery)</b> according
                    to the assignment terms.
                </>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Hardcover - BuyOut",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title2: "Upload proof of purchase",
            description2: "Please upload a clear screenshot or photo of your Amazon order. Reading the book is optional.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Upload your proof of purchase",
            full_subtitle2: "Make sure the screenshot/photo clearly shows key details.",
            full_description2: (
                <p>
                    Upload a <b>clear screenshot or photo</b> of your Amazon order page that shows the Order
                    ID or number,
                    the book title (or ASIN), the order date, the price paid for the book, and your Amazon
                    account name.
                    Files must be readable, and blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after
                    reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>book’s retail price
                    (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Hardcover - BuyOut",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title3: "Turn in this assignment",
            description3: "You are on the third step now! Click “Turn In” to submit your assignment to start verification process.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after
                    reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>book’s retail price
                    (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Hardcover - BuyOut",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title4: "Awaiting verification & payout",
            description4: "We received your submission. We’ll verify it and credit upon approval. You’ll be notified soon.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification & reimbursement in progress",
            full_subtitle4: "We’re reviewing your files and confirming order details.",
            full_description4: (
                <>
                    Our team is verifying your purchase with the provided screenshots/photos and Amazon order details.
                    If anything is missing or unclear, we’ll ask you to re-upload the files. Once approved, we will
                    credit your <b>Virt</b> and reimburse the <b>book’s retail price (excluding delivery)</b> according
                    to the assignment terms.
                </>
            ),
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Hardcover - BuyOut",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Upload proof of purchase",
            description2: "We’ve reviewed and validated your proof — all good, nicely done and confirmed! Great job!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "Assignment submitted successfully and verified — great job completing it thoroughly and fast!",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your BuyOut assignment is fully confirmed! Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <p>
                    This BuyOut assignment is now closed. You have received your <b>Virt</b> and
                    reimbursement of the
                    <b> book’s retail price (excluding delivery)</b>. Please note that if verification later
                    reveals
                    discrepancies in your submitted files, adjustments to your balance may still be
                    required.
                    Thank you for completing the assignment!
                </p>
            ),

            verified_purchase: "Not required",
            photo: "Not needed",
            review_name: user?.user?.amz_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },

    },
});
